import React from "react";
import { Bar } from "react-chartjs-2";
import Card from "@/components/common/card/Card";
import styles from "./ThematicAreas.module.css";
import { useCardFilters } from "../useCardFilter";
import { useThematicAreasChart } from "./useThematicAreasChart";
import CardTestFilter from "../CardTestFilter";
import type { thematicAreasProps } from "../types.props";

const ThematicAreasCard: React.FC<thematicAreasProps> = ({
    thematicAreas,
    view = "vsInstitution",
}) => {
    const { selectedTest, testOptions, filteredData, handleTestChange } =
        useCardFilters(thematicAreas);

    const { chartData, chartOptions } = useThematicAreasChart(filteredData, view);

    const headerActions = (
        <CardTestFilter
            options={testOptions}
            selectedValue={selectedTest}
            onChange={handleTestChange}
        />
    );

    return (
        <Card
            title="Desempeño por áreas temáticas"
            icon="📊"
            headerActions={headerActions}
        >
            {filteredData.length === 0 ? (
                <p className={styles["no-data"]}>
                    No hay datos de áreas temáticas para el filtro seleccionado.
                </p>
            ) : (
                <div className={styles["chart-container"]}>
                    <Bar data={chartData} options={chartOptions} />
                </div>
            )}
        </Card>
    );
};

export default ThematicAreasCard;
